/**
 * pedidoEstados.ts — Estados de pedido de la tienda virtual (fuente única).
 *
 * QUÉ HACE: Centraliza los estados "no terminales" (pedidos que siguen en
 * espera de atención en el local) para que caja y el watcher de auto-impresión
 * compartan el mismo criterio sin duplicarlo.
 *
 * QUÉ EXPORTA: ESTADOS_PEDIDOS_ACTIVOS
 *
 * QUÉ NO DEBE HACER:
 *  - No contiene lógica: solo datos.
 *  - No importa React ni servicios.
 */
import type { EstadoPedido } from "../types/tienda.types";

/** Estados no terminales: pendiente/confirmado/preparando/listo. */
export const ESTADOS_PEDIDOS_ACTIVOS: EstadoPedido[] = [
  "pendiente",
  "confirmado",
  "preparando",
  "listo",
];
